<template>
  <v-container
    fluid
    :class="`rounded-lg elevation-${elevation} px-4 py-4 d-flex flex-column`"
    style="height: 100%; background-color: var(--color-bg)"
  >
    <slot name="header" />
    <v-container
      class="pa-0"
      style="background-color: transparent; height: 100%; position: relative"
    >
      <highcharts
        v-if="!loading"
        :options="chartOptions"
        class="chart-container"
      />
      <slot
        v-else
        name="loading-component"
      />
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "LoadingChartContainer",
  props: {
    chartOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    elevation: {
      type: Number,
      required: false,
      default: 0,
    },
  },
};
</script>

  <style scoped>
.chart-container {
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
